import * as React from "react";
import { Theme } from "@mui/styles";

import  { withStyles } from '@mui/styles';

import { WithStyles, StyleRules, ClassNameMap } from '@mui/styles/withStyles';

import { Button } from "@mui/material";
import { Typography } from "@mui/material";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
} from "@mui/material";
import { Grid } from "@mui/material";
import * as request from "superagent";
import URLManager from "~common/lib/url-manager";
import { setValueAtPath, getValueAtPath } from "~common/form/helper";
import DefinitionSection from "~common/form/definition-section";
import CookieManager from "~common/lib/cookie-manager";
import Renderers from "~common/lib/renderers";

type State = {
  open: boolean;
  status: "loading" | "ready"
  data: any;
  portalInviteAuthToken: any;
  onboardingProfile: any;
  form?: any;
  policyMessages: Array<any>;
  error?: any;
};

interface Props extends React.HTMLProps<HTMLDivElement> {
  classes: any;
  open: boolean;
  action: any;
  handleDispatch: (action: any, data: any) => void;
  handleClose: () => void;
}

const styles = (theme: Theme): StyleRules => ({
  modalContent: {
    width: 500,
  },
  actionAutoConfirmButtonClass: {
    border: "dashed 1px #dedede",
  },
  modalTitle: {
    padding: "0px 0px 20px 0px",
  },
  gridItem: {
    paddingBottom: "0px !important;",
    paddingTop: "0px !important;",
  },
  controlContainer: {
    width: "100%",
    padding: 0,
  },
  dangerButton: {
    backgroundColor: "#af0202",
    "&:hover": {
      backgroundColor: "#5D0A0A !important",
    },
  },
});

class InviteOnboardigUserDialogue extends React.Component<
  Props & WithStyles<keyof typeof styles>,
  State
> {
  constructor(props: Props) {
    super(props, {});
    this.state = {
      status: "loading",
      open: true,
      data: {},
      policyMessages: [],
    };
  }

  static register = () => {
    if (!Renderers.find("InviteOnboardigUserDialogue")) {
      Renderers.register(
        "InviteOnboardigUserDialogue",
        withStyles(styles)(InviteOnboardigUserDialogue)
      );
    }
  };
  
  componentDidMount() {
    var {task} = this.props
    request.get(`/api/invoice-processing/validate-vendor-setup-invite/${task.id}`).then((response: request.Resonse)=>{
      if (!response.body.portalAuthToken && !response.body.onboardingProfile) {
        this.setState({status: "ready"})
      } else {
        if (response.body.portalAuthToken) {
          this.setState({
            status: "ready",
            portalInviteAuthToken: response.body.portalAuthToken
          })
        } else {
          this.setState({
            status: "ready",
            onboardingProfile: response.body.onboardingProfile
          })
        }
      }
    }).catch((err)=>{
      console.log(err)
    })
  }

  handleDispatch = () => {
    var {task} = this.props
    console.log("handleDispatch", task)
    // do the dispatch without using the dispatch provider
    // dispatch will just unlock the payables_task
    // then this component will direct the user to the existing Onboarding User Invite feature
    // unlock the task 
   request.put(`/api/payables_task/tasks/${task.id}/unlock`).then(()=>{
    window.location.href = `/onboarding/invite?vendorSetupTaskID=${task.id}`
   }).catch((err)=>{
    window.location.href = `/onboarding/invite?vendorSetupTaskID=${task.id}`
   })
  };

  handleClose = () => {
    if (this.props.handleClose) {
      this.props.handleClose();
    }
  };

  invalidateAuthToken = () => {
    const {portalInviteAuthToken} = this.state
    const {task} = this.props
    request.put(`/api/invoice-processing/invalidate-invite-token/${portalInviteAuthToken.token}`).then(()=>{
      window.location.href = `/onboarding/invite?vendorSetupTaskID=${task.id}`
    }).catch((err)=>{
      console.log("err", err)
    })
  }

  render() {
    const { classes }: { classes: ClassNameMap } = this.props;
    const { status, portalInviteAuthToken, onboardingProfile } = this.state;


    console.log("this.state", this.state)

    if (portalInviteAuthToken) {

      var dialogueMessage = `An invite has already been sent to ${portalInviteAuthToken.extendedAttributes.emailAddress}. Would you like to cancel this invite and send a new one?`
      return (
        <Dialog
          className={classes.modal}
          open={status == "ready"}
          onClose={this.handleClose}
        >
          <DialogContent className={classes.modalContent}>
            <DialogTitle className={classes.modalTitle}>
              {"Invite Onboarding User"}
            </DialogTitle>
            <Grid container spacing={3}>
                <Grid item xs={12} sm={12} md={12} lg={12}>
                  <Typography
                    dangerouslySetInnerHTML={{
                      __html: dialogueMessage,
                    }}
                    variant="body1"
                  ></Typography>
                </Grid>
            </Grid>
          </DialogContent>
          <DialogActions style={{ justifyContent: "flex-start" }}>
            <div style={{ flex: 1 }}></div>
            <Button
              variant="contained"
              color="inherit"
              onClick={this.handleClose.bind(this, false)}
            >
              {"No"}
            </Button>
            {
              <Button
                autoFocus={true}
                variant="contained"
                color="primary"
                onClick={this.invalidateAuthToken.bind(this)}
              >
                {"Yes"}
              </Button>
            }
          </DialogActions>
        </Dialog>
      );
    } else if (onboardingProfile) {
      var dialogueMessage = `Onboarding packet ${onboardingProfile.id} has already been created for this vendor setup task.`
      return (
        <Dialog
          className={classes.modal}
          open={status == "ready"}
          onClose={this.handleClose}
        >
          <DialogContent className={classes.modalContent}>
            <DialogTitle className={classes.modalTitle}>
              {"Invite Onboarding User"}
            </DialogTitle>
            <Grid container spacing={3}>
                <Grid item xs={12} sm={12} md={12} lg={12}>
                  <Typography
                    dangerouslySetInnerHTML={{
                      __html: dialogueMessage,
                    }}
                    variant="body1"
                  ></Typography>
                </Grid>
            </Grid>
          </DialogContent>
          <DialogActions style={{ justifyContent: "flex-start" }}>
            <div style={{ flex: 1 }}></div>
            <Button
              variant="contained"
              color="inherit"
              onClick={this.handleClose.bind(this, false)}
            >
              {"Close"}
            </Button>
          </DialogActions>
        </Dialog>
      );
    } else {
      return (
        <Dialog
          className={classes.modal}
          open={status == "ready"}
          onClose={this.handleClose}
        >
          <DialogContent className={classes.modalContent}>
            <DialogTitle className={classes.modalTitle}>
              {"Invite Onboarding User"}
            </DialogTitle>
            <Grid container spacing={3}>
                <Grid item xs={12} sm={12} md={12} lg={12}>
                  <Typography
                    dangerouslySetInnerHTML={{
                      __html: "Are you sure you would like to invite an onboarding user? You will be re-directed to the invitation form.",
                    }}
                    variant="body1"
                  ></Typography>
                </Grid>
            </Grid>
          </DialogContent>
          <DialogActions style={{ justifyContent: "flex-start" }}>
            <div style={{ flex: 1 }}></div>
            <Button
              variant="contained"
              color="inherit"
              onClick={this.handleClose.bind(this, false)}
            >
              {"No"}
            </Button>
            {
              <Button
                autoFocus={true}
                variant="contained"
                color="primary"
                onClick={this.handleDispatch.bind(this)}
              >
                {"Yes"}
              </Button>
            }
          </DialogActions>
        </Dialog>
      );
    }
  }
} 

export default withStyles(styles)(InviteOnboardigUserDialogue);